import { useNavigate } from 'react-router-dom';

import { AdminButton } from '@/components/admin/button';
import { Card, CardBody } from '@/components/admin/card';
import { PageHead } from '@/components/admin/page-head';

/**
 * Écran « accès refusé » affiché dans le layout admin quand l'utilisateur
 * navigue vers une page hors de son périmètre métier (8.3). Le serveur bloque
 * déjà les données (403) ; ceci évite un écran vide/erreur et matérialise le
 * cloisonnement côté navigation.
 */
export function ForbiddenView() {
  const navigate = useNavigate();
  return (
    <>
      <PageHead title="Accès non autorisé" sub="Cette section est hors de votre périmètre" />
      <Card>
        <CardBody>
          <div className="empty" data-testid="forbidden-view">
            Vous n'avez pas les permissions nécessaires pour consulter cette page.
            <div style={{ marginTop: 12 }}>
              <AdminButton variant="secondary" onClick={() => navigate('/')}>
                Retour à l'accueil
              </AdminButton>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
